<span class="error" *ngIf="componentForm.submitted">
  <span *ngIf="formFieldReference?.errors?.required">{{"ERRORS.IS_REQUIRED" | translate}}</span>
</span>
